import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { GlobalProvider } from './context/GlobalContext';
import Layout from './components/Layout/Layout';
import Login from './components/Login/Login';
import DynamicPage from './pages/DynamicPage';
import NotFound from './pages/NotFound';
import './App.css';

// El branding (colores de tema, logo, etc.) viene de Strapi via GlobalProvider
// y debe aplicarse al documento aunque todavia no haya sesion (por eso
// GlobalProvider envuelve tambien el login). Lo que SI se gatea detras de la
// sesion es el contenido: Header, Footer y las rutas solo se montan
// autenticado.
const AppGate = () => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) return null;
  if (!isAuthenticated) return <Login />;

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<DynamicPage />} />
          <Route path=":slug" element={<DynamicPage />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

function App() {
  return (
    <GlobalProvider>
      <AuthProvider>
        <AppGate />
      </AuthProvider>
    </GlobalProvider>
  );
}

export default App;
